<template>
  <div class="index">
    <!-- banner -->
    <slider :sliderData="sliderData"></slider>
    <!-- 无图新闻(信息公告+人事政策) -->
    <div class="wutuDiv1">
      <div class="w69">
        <xxgg
          :xxggList="xxggList"
          moreLink="/list.html?HType=2&CId=6271"
        ></xxgg>
      </div>
    </div>
    <div v-if="zydata.length > 1">
      <rotation :sliderData="zydata"></rotation>
    </div>

    <!-- 无图新闻（职称评聘+师资建设） -->
    <div class="wutuDiv2">
      <div class="w69">
        <szjs
          :szjsList="szjsList"
          moreLink="/list.html?HType=2&CId=6270"
        ></szjs>
      </div>
    </div>
    <!-- <bottomMenu :dataList="bottomMenuList"></bottomMenu> -->
    <div style="height: 0.25rem"></div>
  </div>
</template>
<script>
import "../assets/css/index.css";
import "../assets/js/init.js";
import "../assets/js/wow.js";
import slider from "@/components/slider";
import xxgg from "@/components/xxgg";
import szjs from "@/components/szjs";
import rotation from "@/components/rotation";
import bottomMenu from "@/components/bottomMenu";
export default {
  name: "index",
  components: {
    slider,
    xxgg,
    rotation,
    bottomMenu,
    szjs
  },
  data() {
    return {
      baseUrl: "this.baseUrl",
      sliderData: [],
      xxggList: [],
      zydata: [],
      zcppList: [],
      szjsList: []
    };
  },
  created() {
    this.$root.$children["0"].$children["0"].menuListOne.forEach(
      element => (element.On = false)
    );
    this.sliderData = this.Base.GetFilesInfoByCid(6267, 1, "", 200, 1); //banner
    this.xxggList = this.Base.GetNewsInfoByCid(6271, false, 1, "", 3); //信息公告
    this.zydata = this.Base.GetNewsInfoByCid(6272, false, 1, "", 12);
    this.szjsList = this.Base.GetNewsInfoByCid(6270, false, 1, "", 4);
    this.bottomMenuList = this.Base.GetNewsInfoByCid(6383, false, 1, "", 20);
  }
};
</script>
<style lang="less" scoped>
.formBox {
  width: 5.45rem;
  margin: 0 auto;
  form {
    margin-top: 0.54rem;
  }
  /deep/.el-select {
    width: 100%;
    margin-bottom: 0.4rem;
    input {
      height: 0.8rem;
      line-height: 0.8rem;
      padding-left: 0.6rem;
    }
    .el-input__suffix {
      right: 0.33rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue